/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useMemo, useState } from 'react';
import { Alert, Checkbox, Icon, IconButton, LinearProgress, Pagination, Paper, Snackbar, SnackbarCloseReason, Switch, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TableRow } from '@mui/material';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { LayoutBaseDeFinanceiro, } from '../../../shared/layouts';
import { useDebounce } from '../../../shared/hooks';
import { Environment } from '../../../shared/environment';
import dayjs from 'dayjs';
import { FerramentasDaListagemFinanceiro } from '../../../shared/components';
import { DialoDesconto } from './DialogDesconto';
import { DialoBaixa } from './DialogBaixa';
import { v4 as uuidv4 } from 'uuid';
import { ContasPagarService, IListagemContasPagar } from '../../../shared/services/api/Financeiro/ContasPagar';
import PDFPagar from './ImpressaoPagar';

export const ListagemContasPagar: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { debounce } = useDebounce();
  const navigate = useNavigate();  
  const [rows, setRows] = useState<IListagemContasPagar[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [istexto, setIsTexto] = useState(false);
  const [isAutoComplete, setIsAutoComplete] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [total, setTotal] = useState(0);
  const [selecionado, setSelecionado] = useState(0);
  const [open, setOpen] = useState(false);
  const [openBaixa, setOpenBaixa] = useState(false);
  const [nome, setNome] = useState('');
  const [data, setData] = useState(true);
  const [bstatus, setBstatus] = useState(true);
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error'  | 'info'  | 'success'>('warning');  
            
  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event, 
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
  }; 
    
  const guuid = uuidv4();   
  
  const busca = useMemo(() => {
    return searchParams.get('busca') || '';
  }, [searchParams]);

  const dataInicial = useMemo(() => {
    return searchParams.get('datainicial') || dayjs().format('DD/MM/YYYY').toString();
  }, [searchParams]);
  
  const dataFinal = useMemo(() => {
    return searchParams.get('datafinal') || dayjs().format('DD/MM/YYYY').toString();
  }, [searchParams]);

 
  const basicstatus = useMemo(() => {
    return searchParams.get('basicstatus') || 'false'; 
  }, [searchParams]);

  const parceiroselect = useMemo(() => {
    return searchParams.get('parceiroselect') || ''; 
  }, [searchParams]);

  const tipo = useMemo(() => {
    return searchParams.get('tipo') || 'r.vencimento'; 
  }, [searchParams]);


  const idparceiro = useMemo(() => {
    return searchParams.get('parceiro') || ''; 
  }, [searchParams]);

  const pagina = useMemo(() => {
    return Number(searchParams.get('pagina') || '1');
  }, [searchParams]);
  
  function verificaFormato(data: string) {
    const regex = /^\d{2}\/\d{2}\/\d{4}$/;
    return regex.test(data);
  }

  useEffect(() => {
    if(tipo === 'r.vencimento'){
      setData(true);
      setIsTexto(false);
      setIsAutoComplete(false);
      setRows([]);
      setSearchParams({tipo: 'r.vencimento', pagina: '1'}, { replace: true });
      setTotalCount(0);
      setBstatus(true);
    }
    else if(tipo === 'r.idparceiro'){
      setIsAutoComplete(true);
      setIsTexto(false);
      setData(false);
      setRows([]); 
      setSearchParams({tipo: 'r.idparceiro', pagina: '1'}, { replace: true });
      setTotalCount(0);
      setBstatus(false);
    }else{
      setIsTexto(true);
      setIsAutoComplete(false);
      setData(false);
      setRows([]);
      setSearchParams({tipo: 'r.numerodoc', pagina: '1'}, { replace: true });
      setTotalCount(0);
      setBstatus(true);
    }
  }, [tipo]);

  useEffect(() => {
    if (tipo === 'r.numerodoc' && busca != '') { 
      setIsLoading(true);
      debounce(() => {
        ContasPagarService.getAll(pagina, '', '', busca, 'numero')
          .then((result) => {
            setIsLoading(false);
            if (result instanceof Error) {
              setTms('error');
              setMsg(result.message);
              setOpenmsg(true);
            } else {
              setTotalCount(result.totalCount);
              setSelecionado(result.selecionado); 
              setTotal(result.total); 
              setRows(result.data);
            }
          });
      }); 
    } 
      
  }, [busca, pagina]);
  
  useEffect(() => {
    if (tipo === 'r.vencimento' && verificaFormato(dataInicial) && verificaFormato(dataFinal)) { 
      setIsLoading(true);
      debounce(() => {
        ContasPagarService.getAll(pagina, dataInicial, dataFinal, '', 'data')
          .then((result) => {
            setIsLoading(false);
            if (result instanceof Error) {
              setTms('error');
              setMsg(result.message);
              setOpenmsg(true);
            } else {
              setTotalCount(result.totalCount);
              setRows(result.data);
              setSelecionado(result.selecionado); 
              setTotal(result.total); 
            }
          });
      });
    }else{
      setRows([]);
    }        
  }, [dataInicial, dataFinal, pagina]);
  
  useEffect(() => {
    if (tipo === 'r.idparceiro' && idparceiro != '') { 
      setIsLoading(true);
      setNome(parceiroselect);
      debounce(() => {
        ContasPagarService.getAll(pagina, '', '', idparceiro, 'parceiro')
          .then((result) => {
            setIsLoading(false);
            if (result instanceof Error) {
              setTms('error');
              setMsg(result.message);
              setOpenmsg(true);
            } else {
              setTotalCount(result.totalCount);
              setRows(result.data);
              setSelecionado(result.selecionado); 
              setTotal(result.total); 
            }
          });
      });
    }else{
      setRows([]);
    }    
  }, [idparceiro]);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { id, checked } = event.target;
    const index = rows.findIndex(row => row.idcontaspagar === id);
    if (index === -1) return; 
    const updatedRow = { ...rows[index], marcado: checked };
    const updatedRows = [...rows.slice(0, index), updatedRow, ...rows.slice(index + 1)];
    setRows(updatedRows);
    const valueToUpdate = checked ? updatedRow.valorpagar : -updatedRow.valorpagar;
    setSelecionado(currentSelecionado => currentSelecionado + valueToUpdate);
  };

  const handleSelectAllChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;
    const updatedRows = rows.map(row => {
      if (row.boleto) {
        return  { ...row, marcado: checked };
      }else{
        return  { ...row, marcado: false };
      }
    });
    setRows(updatedRows);
    if (checked) {
      const totalSelecionado = updatedRows
        .filter(row => row.boleto && row.marcado)
        .reduce((acc, row) => acc + row.valorpagar, 0);
      setSelecionado(totalSelecionado);
    } else {
      setSelecionado(0);
    }
  };
  
  const handleClose = (newValue?: string) => {
    setOpen(false);

    if (newValue) {     
      // setValue(newValue); 
    }          
  };  
            
  const handleCloseBaixa = (newValue?: string) => {
    setOpenBaixa(false);  
    if (newValue === 'true') {
      ContasPagarService.getAll(pagina, '', '', idparceiro, 'parceiro')
        .then((result) => {
          setIsLoading(false);
          if (result instanceof Error) {
            setTms('error');
            setMsg(result.message);
            setOpenmsg(true);
          } else {
            setTotalCount(result.totalCount);
            setTotal(result.total);
            setSelecionado(result.selecionado);
            setRows(result.data);
          }
        });
    }
  };  

  const handleDesconto = () => {
    if(totalCount != 0){
      const filteredList = rows.filter((item) => item.marcado === true);
      setRows(filteredList);
      setOpen(true);
    }
  };

  const handleBaixa = () => {
    if(totalCount != 0){
      const filteredList = rows.filter((item) => item.marcado === true);
      setRows(filteredList);
      setOpenBaixa(true);
    }
  };

  const handleSave = async () => {
    if(totalCount != 0){
      setIsLoading(true);
      const marcados = rows.map(listItem => ({
        idcontaspagar: listItem.idcontaspagar,
        marcado: listItem.marcado,
        desconto: listItem.desconto,
        valorpagar: listItem.valorpagar,

      }));
      try {
        const result = await ContasPagarService.Marcados(marcados);
        setIsLoading(false);
        if (result instanceof Error) {
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);
        } 
      } catch (error) {
        setIsLoading(false);
        setTms('error');
        setMsg('Ocorreu um erro ao processar.');
        setOpenmsg(true);
      }
    }
  };

  const handlePrint = () => {
    if(totalCount != 0){
      const filteredList = rows.filter((item) => item.marcado === true);
      PDFPagar(filteredList, total, nome);
    }      
  };   

  const handleDesc = (dados?: IListagemContasPagar[]) => {
    if (dados) {
      setRows(dados);
    }
  };

  const handletotal = (valor?: number) => {
    if (valor) {
      setSelecionado(valor);
    }
  };

  return (
    <LayoutBaseDeFinanceiro
      titulo='Contas a Pagar'
      labelSelecionado='Selecionado'
      labeltotal='Total Pagar'
      total={total.toLocaleString('pt-BR', { minimumFractionDigits: 2})}
      selecionado={selecionado.toLocaleString('pt-BR', { minimumFractionDigits: 2})}
      barraDeFerramentas={
        <FerramentasDaListagemFinanceiro
          mostrarInputBusca={istexto}
          mostrarInputData={data}
          mostrarAutoComplete={isAutoComplete} 
          mostrarInputBasicSelect
          textSelectFalse='Pagar'
          textSelectTrue='Pagas'
          textoDaBusca={busca}
          dataInicial={dataInicial}
          dataFinal={dataFinal}
          textoDoSelect={tipo}
          textoDoStatus={basicstatus}
          disbilitarBaixar={bstatus ? true : false}
          disbilitarDesconto={bstatus ? true : false}
          disbilitarSalvar={bstatus ? true : false}
          disbilitarImprimir={bstatus ? true : false}
          textoBotaoNovo='Adicionar'
          aoClicarEmNovo={() => navigate('/contaspagar/detalhe/novo')}
          aoClicarEmDesconto={handleDesconto}  
          aoClicarEmSalvar={handleSave}
          aoClicarEmBaixa={handleBaixa}
          aoClicarEmImpressao={() => handlePrint()}
          aoMudarDataInicial={dataInicial => setSearchParams({ tipo: tipo, pagina: '1', datainicial: dataInicial, datafinal: dataFinal }, { replace: true })}
          aoMudarDataFinal={datafinal => setSearchParams({ tipo: tipo, pagina: '1', datainicial: dataInicial, datafinal: datafinal }, { replace: true })}
          aoMudarTextoDeBusca={texto => setSearchParams({ busca: texto, tipo: tipo, pagina: '1', datainicial: dataInicial, datafinal: dataFinal }, { replace: true })}
          aoMudarTextoDoSelect={textoselect => setSearchParams({ busca: busca, tipo: textoselect, pagina: '1', datainicial: dataInicial, datafinal: dataFinal  }, { replace: true})}
          aoMudarTextoDoParceiro={(texto, texto1) => setSearchParams({ parceiroselect: texto1, parceiro: texto, busca: busca, tipo: tipo, pagina: '1', datainicial: dataInicial, datafinal: dataFinal }, { replace: true })}
        />  
      }
    >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg}  autoHideDuration={900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {msg}
        </Alert>
      </Snackbar>
      <TableContainer component={Paper} variant="outlined" sx={{ m: 1, width: 'auto' }}>
        <Table>
          <Table size="small">  
            <TableHead>
              <TableRow>
                <TableCell> <Checkbox  checked={rows.length > 0 && rows.every(row => row.marcado)} onChange={handleSelectAllChange} /></TableCell>
                <TableCell align='left' style={{ fontSize: 12 }}>Parceiro</TableCell>
                <TableCell align='left' style={{ fontSize: 12 }}>CPF/CNPJ</TableCell>
                <TableCell align='center' style={{ fontSize: 12 }}>Emissão</TableCell>
                <TableCell align='center' style={{ fontSize: 12 }} >Vencimento</TableCell>
                <TableCell align='center' style={{ fontSize: 12 }}>Parcela</TableCell>
                <TableCell align='right' style={{ fontSize: 12 }} >Numero</TableCell>
                <TableCell align='right' style={{ fontSize: 12 }} >Valor</TableCell>
                <TableCell align='right' style={{ fontSize: 12 }} >Valor Parcela</TableCell>
                <TableCell align='right' style={{ fontSize: 12 }} >Juros/Acré...</TableCell>
                <TableCell align='right' style={{ fontSize: 12 }} >Valor Pago</TableCell>
                <TableCell align='right' style={{ fontSize: 12 }} >Desconto</TableCell>
                <TableCell align='right' style={{ fontSize: 12 }} >Valor Pagar</TableCell>
                {/* <TableCell style={{ fontSize: 12 }}>LCDPR</TableCell> */}
                <TableCell align='center'style={{ fontSize: 12 }} ></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map(row => (
                <TableRow key={row.idcontaspagar} 
                  hover
                  sx={{ cursor: 'pointer' }}  
                >
                  <TableCell style={{ backgroundColor: row.boleto ? 'inherit' : '#ffe2db'}} > 
                    {row.boleto && !row.status ? <Checkbox checked={row.marcado} id={row.idcontaspagar} onChange={handleChange} />: '' }</TableCell>
                  <TableCell style={{ fontSize: 12,  color: row.venc ? '#db4a39' : row.boleto ? 'inherit' : '#ff9615'}} align='left'>{row.nome}</TableCell>
                  <TableCell align='left' style={{ fontSize: 12,  color: row.venc ? '#db4a39' : row.boleto ? 'inherit' : '#ff9615'}}>
                    { row.cpf.length == 11 ? (
                      row.cpf.replace(/\D/g, '').replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
                    ) : (
                      row.cpf.replace(/\D/g, '').replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
                    )}                                    
                  </TableCell>
                  <TableCell style={{ fontSize: 12,  color: row.venc ? '#db4a39' : row.boleto ? 'inherit' : '#ff9615'}} align='center'>{dayjs(row.dataemissao).format('DD/MM/YYYY')}</TableCell>
                  <TableCell style={{ fontSize: 12, color: row.venc ? '#db4a39' : row.boleto ? 'inherit' : '#ff9615'}} align='center'>{dayjs(row.vencimento).format('DD/MM/YYYY')}</TableCell>
                  <TableCell style={{ fontSize: 12,  color: row.venc ? '#db4a39' : row.boleto ? 'inherit' : '#ff9615'}} align='center'>{row.parcela}</TableCell>
                  <TableCell style={{ fontSize: 12,  color: row.venc ? '#db4a39' : row.boleto ? 'inherit' : '#ff9615'}} align='right'>{row.numerodoc}</TableCell>
                  <TableCell style={{ color: row.venc ? '#db4a39' : row.boleto ? 'inherit' : '#ff9615'}} align='right'>{row.valornota.toLocaleString('pt-BR', { minimumFractionDigits: 2})}</TableCell>
                  <TableCell style={{ color: row.venc ? '#db4a39' : row.boleto ? 'inherit' : '#ff9615'}} align='right'>{row.valorparcela.toLocaleString('pt-BR', { minimumFractionDigits: 2})}</TableCell>
                  <TableCell style={{ color: row.venc ? '#db4a39' : row.boleto ? 'inherit' : '#ff9615'}} align='right'>{row.acrescimo.toLocaleString('pt-BR', { minimumFractionDigits: 2})}</TableCell>
                  <TableCell style={{ color: row.venc ? '#db4a39' : row.boleto ? 'inherit' : '#ff9615'}} align='right'>{row.valorpago.toLocaleString('pt-BR', { minimumFractionDigits: 2})}</TableCell>
                  <TableCell style={{ color: row.venc ? '#db4a39' : row.boleto ? 'inherit' : '#ff9615'}} align='right'>{row.desconto.toLocaleString('pt-BR', { minimumFractionDigits: 2})}</TableCell>
                  <TableCell style={{ color: row.venc ? '#db4a39' : row.boleto ? 'inherit' : '#ff9615'}} align='right'>{row.valorpagar.toLocaleString('pt-BR', { minimumFractionDigits: 2})}</TableCell>
                  {/* <TableCell>
                    <Switch size='small' checked={row.lcdpr} />
                  </TableCell> */}
                  <TableCell>
                    <IconButton size='small'  onClick={() => navigate(`/contaspagar/detalhe/${row.idcontaspagar}`)}>
                      <Icon >edit</Icon>
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>    
   
            {totalCount === 0 && !isLoading && (
              <caption>{Environment.LISTAGEM_VAZIA}</caption>
            )}
            <TableFooter>
              {isLoading && (
                <TableRow>
                  <TableCell colSpan={12}>
                    <LinearProgress variant='indeterminate' />
                  </TableCell>
                </TableRow>
              )}             
              {tipo !== 'r.idparceiro' && totalCount > 0 && totalCount > 20 && (
                <TableRow>
                  <TableCell colSpan={12}>
                    <Pagination
                      page={pagina}
                      count={Math.ceil(totalCount / 20)}
                      onChange={(_, newPage) =>
                        setSearchParams(
                          {
                            busca: busca,
                            datainicial: dataInicial, 
                            datafinal: dataFinal,
                            tipo: tipo,
                            parceiroselect: idparceiro,
                            pagina: newPage.toString(),
                          },
                          { replace: true }
                        )
                      }
                    />
                  </TableCell>   
                </TableRow>
              )}
            </TableFooter> 
          </Table>
        </Table>
      </TableContainer>
      <DialoDesconto
        open={open} 
        onClose={handleClose}
        dados={rows}
        onDados={handleDesc}
        ontotal={handletotal}
        vselecionado={selecionado}
      /> 
      <DialoBaixa
        value={guuid}
        open={openBaixa} 
        onClose={handleCloseBaixa}
        dados={rows}
        onDados={handleDesc}
        ontotal={handletotal}
        vselecionado={selecionado}
      /> 
    </LayoutBaseDeFinanceiro>
  ); 
};